import React from 'react';
import PropTypes from 'prop-types';
import './tag.scss';

const Tag = ({
  children,
  onClick,
  route,
  native
}) => React.createElement("a", {
  href: route,
  type: "button",
  onClick: onClick,
  className: "tag"
}, children);

Tag.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onClick: PropTypes.func.isRequired
};
export default Tag;